<template>
    <GmapMap
            :center="start"
            :zoom="7"
            :style="`width: 100%;height:`+($vuetify.breakpoint.smAndUp ? 400:150)+`px;`"
    >
        <GmapMarker
                :position="start"
                :icon="{url: require('../../assets/icons/map-building.svg')}"
        ></GmapMarker>
        <DirectionsRenderer
                :travelMode="travelMode"
                :origin="origin"
                :destination="destination"
                v-on:rendered="$emit('renderSuccessful', $event)"
        />
    </GmapMap>
</template>

<script>
    import { Map as GmapMap, Marker as GmapMarker, gmapApi } from 'gmap-vue'
    import DirectionsRenderer from "./DirectionsRenderer";

    export default {
        name: "GoogleMapsDirection",
        components: {
            GmapMap, GmapMarker, DirectionsRenderer
        },
        props: {
            start: {
                default() {
                    return {
                        lat: 42.0963462,
                        lng: -70.9708055
                    }
                }
            },
            end: {
                default() {
                    return {
                        lat: 42.1210441,
                        lng: -71.0322845
                    }
                }
            },
            height: {
                default() {
                    return 400
                }
            },
            travelMode: {
                default() {
                    return 'DRIVING'
                }
            }
        },
        computed: {
            google: gmapApi,

            origin() {
                if (!this.start || !this.google) return null;
                return new this.google.maps.LatLng(this.start.lat, this.start.lng);
            },
            destination() {
                if (!this.end || !this.google) return null;
                return new this.google.maps.LatLng(this.end.lat, this.end.lng);
            },
        }
    }
</script>
